import React from 'react';

const AllProductsSkeleton = () => {
  // Sub-component for a single table row skeleton
  const TableRowSkeleton = () => (
    <tr className="animate-pulse">
      <td className="px-6 py-4">
        <div className="flex items-center gap-4">
          {/* Product Image Square */}
          <div className="h-14 w-14 bg-gray-200 rounded-xl flex-shrink-0"></div>
          <div className="space-y-2">
            {/* Product Name Line */}
            <div className="h-4 w-32 bg-gray-200 rounded"></div>
            {/* Brand/Color Line */}
            <div className="h-3 w-20 bg-gray-100 rounded"></div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4">
        {/* Category Line */}
        <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
        {/* Subcategory Line */}
        <div className="h-3 w-16 bg-gray-100 rounded"></div>
      </td>
      <td className="px-6 py-4">
        {/* Stock Number */}
        <div className="h-6 w-10 bg-gray-200 rounded mb-1"></div>
        {/* Labels */}
        <div className="h-2 w-12 bg-gray-100 rounded"></div>
      </td>
      <td className="px-6 py-4">
        {/* Status Badge */}
        <div className="h-6 w-20 bg-gray-100 rounded-full"></div>
      </td>
      <td className="px-6 py-4">
        {/* Action Button */}
        <div className="h-8 w-8 bg-gray-100 rounded-full mx-auto"></div>
      </td>
    </tr>
  );

  return (
    <div className="min-h-screen animate-pulse">
      {/* Header Section Skeleton */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
        <div>
          <div className="h-8 w-48 bg-gray-200 rounded-lg mb-2"></div>
          <div className="h-4 w-32 bg-gray-100 rounded-md"></div>
        </div>
        <div className="h-11 w-36 bg-gray-200 rounded-xl shadow-sm"></div>
      </div>

      {/* Filter Bar Skeleton */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 mb-6 overflow-hidden">
        <div className="p-4 flex flex-col md:flex-row gap-4">
          <div className="flex-1 h-11 bg-gray-50 rounded-xl"></div>
          <div className="h-11 w-28 bg-gray-50 rounded-xl"></div>
        </div>
      </div>

      {/* Table Section Skeleton */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="bg-gray-50/80 border-b">
              <tr>
                {[1, 2, 3, 4, 5].map((i) => (
                  <th key={i} className="px-6 py-5">
                    <div className="h-3 w-16 bg-gray-200 rounded"></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {/* Generate 8 rows of skeleton data */}
              {[...Array(8)].map((_, i) => (
                <TableRowSkeleton key={i} />
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer/Pagination Skeleton */}
        <div className="p-6 border-t flex justify-between items-center bg-gray-50/30">
          <div className="h-4 w-24 bg-gray-200 rounded"></div>
          <div className="flex gap-2">
            <div className="h-9 w-9 bg-gray-200 rounded-xl"></div>
            <div className="h-9 w-9 bg-gray-200 rounded-xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllProductsSkeleton;